// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon{position:relative;width:100%;height:100%}.icon.has-align-fix{top:-.1rem}", ""]);
// Exports
module.exports = exports;
